const _touches = typeof window !== 'undefined' && 'ontouchstart' in window;
const useTouches = () => _touches;
export default useTouches;
